import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ui } from '@/constants';
import { AnalyticsEventCategory, AnalyticsEventAction, AnalyticsEventLabel } from '@/services/google/google-analytics.services';

@Component({
  name: 'CmgRewardsSpendYourPointsModal',
})
export default class CmgRewardsExchangeWelcomeModal extends Vue {
  get isMobile(): boolean {
    return this.$services.ui.isMobile();
  }

  get visible(): boolean {
    return this.$appStore.state.ui.modals.rewardsSpendYourPoints.visible;
  }

  get pepperMedallionImageUrl(): string {
    return this.$appStore.state.cms.images.logos.medallionRewardShout.default;
  }

  get chevronLeftUrl(): string {
    return this.$appStore.state.cms.images.icons.chevronLeft.default;
  }

  onBack() {
    this.$services.ui.setModalVisibility('rewardsSpendYourPoints', false);
    this.$services.ui.setModalVisibility('rewardsExchangeWelcome', true);
  }

  onClickLetsGo(){
    this.$services.googleAnalytics.sendCustomEvent({
      category: AnalyticsEventCategory.RewardsStoreOnboard,
      action: AnalyticsEventAction.LetsGoClick,
      label: AnalyticsEventLabel.LetsGoClick,
    });
    this.onClose();
  }

  onClose() {
    this.$services.ui.setModalVisibility('rewardsSpendYourPoints', false);
    this.$services.ui.focusBack();
  }
}
